module.exports = __webpack_public_path__ + "img/Phone.c401d62b.svg";